import doughnut from '@/components/common/DoughnutChart.js'
import colors from '@/utils/colors.js'
import { PublicHeader } from '../../../components/common/'

export default {
  components: {
    doughnut,
    PublicHeader
  },
  name: 'volta_aulas', 
  data () {
    return {
      escola: '',
      lista_escolas: [],
      informacoes: [],
      cores: [],
      baseModelo: { labels: [], datasets: [{label: '', backgroundColor: [], data: []}] },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        plugins: {
            // Change options for ALL labels of THIS CHART
            datalabels: {
              formatter: (value, ctx) => {
                let sum = 0;
                let dataArr = ctx.chart.data.datasets[0].data;
                dataArr.map(data => {
                    sum += data;
                });
                let percentage = (value*100 / sum).toFixed(2)+"%";
                return percentage;
              },
              color: [
                '#000',
                '#FFF',
                '#000',
                '#FFF',
                '#FFF',
                '#FFF',
                '#000'
              ]
            }
        }
      }
    }
  },
  created () {
    const { pesquisa } = this.$store.state
    this.lista_escolas = pesquisa.escolas
    this.cores = [...colors.coresRGB]
    this.carregarCampos()
  },
  methods: {
    carregarCampos () {
      this.$store.dispatch('carregarEscolas')
        .then(() => {
          const { pesquisa } = this.$store.state
          this.lista_escolas = pesquisa.escolas
        })
        .catch(e => console.log(e))
    },
    listarDados() {
      this.$http.get(`pesquisa/retorno-atividades-escolares/listar-dados/${this.escola}`)
        .then(response => {
          this.informacoes = Object.values(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    geraGraficoPorEntrevistado(responsavel, chave) {
      const informacoes = [...this.informacoes]
      let base = {...this.baseModelo}

      if (!Array.isArray(responsavel)) {
        responsavel = [responsavel]
      }

      if (informacoes.length) {
        let group = informacoes.filter(item => {
          return responsavel.indexOf(item['1. Você é']) > -1
        }).reduce((acumulador, atual) => {
          let result = {...acumulador}
          const indice = atual[chave]
          result[indice] = result[indice] || 0
          result[indice]++
          return result
        }, {})

        let chaves = Object.keys(group)
        let dados = []

        for (let index = 0; index < chaves.length; index++) {
          dados.push(group[chaves[index]])
        }

        base = {
          ...base,
          labels: chaves,
          datasets: [{
            backgroundColor: this.cores,
            data: dados
          }]
        }
      }

      return base
    }
  },
  computed: {
    retornoResultadoGeral() {
      const informacoes = [...this.informacoes]
      let base = {...this.baseModelo}
      const array_base = [
        '7.b De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola em setembro?',
        '6.c De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você profissional da educação se sente seguro em frequentar presencialmente a escola em setembro?',
      ]
      const alunos_maiores = '7.a Aluno/estudante Maior de 18 anos, em relação à COVID-19, quando você retornaria às aulas presenciais?'
      const imediatamente = 'Imediatamente'
      const sim = 'Sim'

      if (informacoes.length) {
        let group = informacoes.reduce((acumulador, atual) => {
          if (atual[array_base[0]] === sim
          || atual[array_base[1]] === sim) {
            acumulador.sim++
          } else if (atual[alunos_maiores] === imediatamente) {
            acumulador.sim++
          } else {
            acumulador.nao++
          }

          return acumulador
        }, { sim: 0, nao: 0 })

        const percentual = ((group.sim / (group.sim + group.nao)) * 100).toFixed(2)

        base = {
          ...base,
          labels: [`Sim`, `Não`],
          datasets: [{
            backgroundColor: this.cores,
            data: [ group.sim, group.nao ]
          }]
        }
      }

      return base
    },
    retornoAlunoMaior () {
      return this.geraGraficoPorEntrevistado(
        'Aluno/estudante maior de 18 anos',
        '7.a Aluno/estudante Maior de 18 anos, em relação à COVID-19, quando você retornaria às aulas presenciais?'
      )
    },
    retornoPaiAluno() {
      return this.geraGraficoPorEntrevistado(
        'Pai/responsável por aluno menor de 18 anos',
        '9.b Pai e/ou responsável, em relação à COVID-19, quando você autorizaria o seu filho a retornar às aulas presenciais?'
      )
    },
    retornoSetembroPai() {
      return this.geraGraficoPorEntrevistado(
        'Pai/responsável por aluno menor de 18 anos',
        '7.b De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola em setembro?'
      )
    },
    retornoOutubroPai() {
      return this.geraGraficoPorEntrevistado(
        'Pai/responsável por aluno menor de 18 anos',
        '8.b Sobre o retorno às aulas presenciais, previsto para outubro, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola?'
      )
    },
    retornoProfissionalEducacao() {
      return this.geraGraficoPorEntrevistado(
        ['Professor', 'Gestor, funcionário ou profissional ligado à educação'],
        '8.c Profissional da educação, em relação à COVID-19, quando você retornaria às aulas presenciais?'
      )
    },
    retornoProfissionalSetembro() {
      return this.geraGraficoPorEntrevistado(
        ['Professor', 'Gestor, funcionário ou profissional ligado à educação'],
        '6.c De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você profissional da educação se sente seguro em frequentar presencialmente a escola em setembro?'
      )
    },
    retornoProfissionalOutubro() {
      return this.geraGraficoPorEntrevistado(
        ['Professor', 'Gestor, funcionário ou profissional ligado à educação'],
        '7.c Sobre o retorno às aulas presenciais, previsto para outubro, você profissional da educação se sente seguro para frequentar presencialmente a escola?'
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/pesquisa/pesquisa.js